import { Component, OnInit } from '@angular/core';
import { slideInUpOnEnterAnimation, slideOutLeftOnLeaveAnimation, } from 'angular-animations';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ParticipantService } from '../../../core/http/participant.service';
import { CompanyService } from '../../../core/http/company.service';
import { RefService } from '../../../core/http/ref.service';
import { FormDataFilterService } from '../../../core/http/form-data-filter.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-contact-update-participant',
  templateUrl: './contact-update-participant.component.html',
  styleUrls: ['./contact-update-participant.component.scss'],
  animations: [
    slideInUpOnEnterAnimation(),
    slideOutLeftOnLeaveAnimation()
  ]
})
export class ContactUpdateParticipantComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private participantService: ParticipantService,
    private companyService: CompanyService,
    private refService: RefService,
    private formDataFilterService: FormDataFilterService
  ) { 
    this.config = {
      currentPage: 1,
      itemsPerPage: this.nbItems
    };

    this.route.queryParamMap.pipe(map(params => params.get('page')))
      .subscribe(page => this.config.currentPage = page || 1);
  }

  listOfAllParticipants: any;
  url: any;
  public href: string;
  mobileRes: boolean;
  filterStatut = false;
  config: any;
  nbItems = 10;
  count: number;
  idEvent: number;
  status: '';
  typeStatus: string = '';
  countItems: any;
  check: boolean = false;
  box: boolean = false;
  initFilter: boolean = true;
  filterFormGroup: any;
  listOfCountry: any;
  listOfType: any;
  listOfCompany: any;
  listOfTypeParticipant: any;
  listOfChecked: any;
  search: string;
  selected: number;
  listOfStatus: any;
  listOfOnsite: any;
  
  ngOnInit() {
    if (this.initFilter) {
      this.filterFormGroup = this.formDataFilterService.dataFilters();
      this.filterFormGroup.valueChanges.subscribe();
      this.refService.getCountry().subscribe(response => {
        this.listOfCountry = response;
      });
      this.refService.getTypeParticipant().subscribe(res => {
        this.listOfType = res;
      });
      this.companyService.getAllCompany().subscribe(res => {
        this.listOfCompany = res;
      });
    }
    this.initFilter = false;
    this.selected = 0;
    this.listOfChecked = [];
    this.box = false;
    if (this.filterFormGroup["value"].search.length <= 0) { this.search = "!" }
    else { this.search = this.filterFormGroup["value"].search; }
    this.participantService.getParticipantByStatusWithPage("all", this.nbItems, this.config.currentPage,
    this.filterFormGroup["value"].idCountry, this.filterFormGroup["value"].idType, this.filterFormGroup["value"].idCompany,
    this.filterFormGroup["value"].vip, this.filterFormGroup["value"].main, this.search).subscribe(res => {
      this.listOfTypeParticipant = res;
    });
  }

  pageChange(newPage: number) {
    this.router.navigate(['admin/contacts'], { queryParams: { page: newPage } });
  }

  onItemsChange(event) {
    this.config.itemsPerPage = event;
    this.ngOnInit();
  }

  checkStatut(event: any) {
    this.filterStatut = event;
  }

  changeFilter() {
    this.ngOnInit();
  }

  resetFilter() {
    this.initFilter = true;
    this.ngOnInit();
  }
}
